import { PayloadAction } from '@reduxjs/toolkit'
import { createReduxSlice } from 'app/app/(client)/redux/ReduxSlice'
import { State } from 'app/types/redux-types'

const initialState: State<boolean> = {
  data: false,
  status: 'idle',
  error: null
}

const appInitializedSlice = createReduxSlice({
  name: 'appInitialized',
  initialState,
  reducers: {
    setData: (state, action: PayloadAction<boolean>) => {
      state.data = action.payload
    }
  }
})

export const { setData: setAppInitialized } = appInitializedSlice.actions
export default appInitializedSlice.reducer
